<!-- KYMW2000 -->
<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">選定済商品数一覧</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area">
        <div class="element-column">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title contents-label">媒体</label>
              <div class="list-input-content">
                <select #cmb_MediumType class="medium-list"
                  [(ngModel)]="model.mediumType" (change)="onChangeMediumType(model.mediumType)" [class.combo-box-required]="true" [tabindex]="0">
                  <ng-template ngFor let-item [ngForOf]="model.mediumList">
                    <option value="{{item.MediumType}}">{{item.MediumTypeName}}</option>
                  </ng-template>
                </select>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title contents-label">受注コード</label>
              <div class="list-input-content">
                <app-order-text-with-catalog #txti_OrderCode [autofocus]="true" [required]="true" [tabindex]="0"
                  [forcedEnabledMode]="'true'" [(ngModel)]="model.orderCode" [width]="'150'"
                  (onChangedCatalogId)="onChangeCatalogId($event)" (ngModelChange)="onChangeText()">
                </app-order-text-with-catalog>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title contents-label">企画回</label>
              <div class="list-input-content">
                <app-catalog-text-with-order #txti_CatalogId [required]="true" [tabindex]="0"
                  [forcedEnabledMode]="'true'" [(ngModel)]="model.catalogId" [width]="'150'"
                  (onChangedOrderCode)="onChangeOrderCode($event)" (ngModelChange)="onChangeText()">
                </app-catalog-text-with-order>
              </div>
            </div>
          </div>
          <button id="btn_Display" forcedenabledmode="true" class="btn-secondary btn-display" tabindex="0"
            (click)="onClickDisplayButton()">表示</button>
        </div>
        <wj-tab-panel #tab_Panel [(selectedIndex)]="tabSelectedIndex" [tabindex]="-1" (selectedIndexChanged)="onChangedTab()">
          <div class="tabBox">
            <wj-tab>
              <a>温度帯（部門別）</a>
              <div class="element-column">
                <div>
                  <div class="column-list">    
                    <label class="list-input-title contents-label">会員生協</label>
                    <div class="list-input-content">
                      <app-coop-code-combo-box id="cmb_CoopCode" #cmb_CoopCode [subid]="'cmb_CoopCode'"
                        [forcedEnabledMode]="'true'" [(ngModel)]="model.deptCoopCode" [autofocus]="false" [width]="'150px'"
                        [tabindex]="0" (ngModelChange)="onChangeCode()">
                      </app-coop-code-combo-box>
                    </div>
                  </div>
                </div>
                <!-- データグリッド 注文コード割当確認一覧 -->
                <wj-flex-grid
                  id="dtg_SelectedGoodsCount" #dtg_SelectedGoodsCount
                  [itemsSource]="model.tempDept" [isReadOnly]="true"
                  forcedEnabledMode="true" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'" [tabindex]="-1">
                  <wj-flex-grid-filter #fltr_tempDept></wj-flex-grid-filter>
                  <wj-flex-grid-column [minWidth]="5" [header]="'部門'" [width]="172" [binding]="'ClassCode'">
                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                      <div *ngIf="cell.item.ClassCode !== 'total'">{{cell.item.ClassCode}}:{{cell.item.ClassName}}</div>
                      <div *ngIf="cell.item.ClassCode === 'total'">{{cell.item.ClassName}}</div>
                    </ng-template>
                  </wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'部門別商品数'" [width]="142" [binding]="'ClassGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'商品数（冷凍）'" [width]="143" [binding]="'FreezedGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'商品数（冷蔵）'" [width]="143" [binding]="'RefrigeratedGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'商品数（常温）'" [width]="143" [binding]="'RoomTempGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'商品数（青果）'" [width]="143" [binding]="'VegetableGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'商品数（パン）'" [width]="143" [binding]="'BreadGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'商品数（別積み）'" [width]="143" [binding]="'OtherStockedGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                </wj-flex-grid>                
              </div>
            </wj-tab>
            <wj-tab>
              <a>温度帯（バイヤー別）</a>
              <div class="element-column">
                <div>
                  <div class="column-list">    
                    <label class="list-input-title contents-label">会員生協</label>
                    <div class="list-input-content">
                      <app-coop-code-combo-box id="cmb_CoopCode" #cmb_CoopCode [subid]="'cmb_CoopCode'"
                        [forcedEnabledMode]="'true'" [(ngModel)]="model.buyerCoopCode" [autofocus]="false" [width]="'150px'"
                        [tabindex]="0" (ngModelChange)="onChangeCode()">
                      </app-coop-code-combo-box>
                    </div>
                  </div>
                </div>
                <!-- 温度帯（バイヤー別） -->
                <wj-flex-grid
                  id="dtg_SelectedGoodsCount" #dtg_SelectedGoodsCount
                  [itemsSource]="model.tempBuyer" textAlign="center" [isReadOnly]="true"
                  forcedEnabledMode="true" [headersVisibility]="'Column'"
                  [allowDragging]="'None'" [selectionMode]="'Row'" [tabindex]="-1">
                  <wj-flex-grid-filter #fltr_tempBuyer></wj-flex-grid-filter>
                  <wj-flex-grid-column [minWidth]="5" [header]="'媒体'" [width]="128" [binding]="'MediumType'">
                    <ng-template  wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                      <div *ngIf="cell.item.ClassCode !== 'total'">{{cell.item.MediumType}}:{{cell.item.MediumName}}</div>
                      <div *ngIf="cell.item.ClassCode === 'total'">{{cell.item.ClassName}}</div>
                    </ng-template>
                  </wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'部門'" [width]="128" [binding]="'ClassCode'">
                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                      <div *ngIf="cell.item.ClassCode !== 'total'">{{cell.item.ClassCode}}:{{cell.item.ClassName}}</div>
                      <div *ngIf="cell.item.ClassCode === 'total'"></div>
                    </ng-template>
                  </wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'担当者'" [width]="126" [binding]="'BuyerName'">  
                  </wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'商品数（冷凍）'" [width]="130" [binding]="'FreezedGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'商品数（冷蔵）'" [width]="130" [binding]="'RefrigeratedGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'商品数（常温）'" [width]="130" [binding]="'RoomTempGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'商品数（青果）'" [width]="130" [binding]="'VegetableGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'商品数（パン）'" [width]="130" [binding]="'BreadGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'商品数（別積み）'" [width]="141" [binding]="'OtherStockedGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                </wj-flex-grid>
              </div>
            </wj-tab>
            <wj-tab>
              <a>注文コード割当（部門別）</a>
              <div class="element-column">
                <div>
                  <div class="block-row">
                    <div class="column-list">    
                      <label class="list-input-title contents-label">注文コード割当</label>
                      <div class="list-input-content">
                        <app-order-num-quota-code-combo-box id="cmb_OrderNumQuota" #cmb_OrderNumQuota
                          [subid]="'cmb_OrderNumQuota'" [required]="true" [blank]="false"
                          [(ngModel)]="model.orderNumQuota" [orderCode]="model.orderCode"
                          [mediumType]="model.mediumType" (loadCompleted)="orderNumQuotaLoadCompleted($event)"
                          [forcedEnabledMode]="'true'" [tabindex]="0" [style.width.rem]="16" (ngModelChange)="onChangeCode()">
                        </app-order-num-quota-code-combo-box>
                      </div>
                    </div>
                    <div class="column-list">
                      <label class="list-input-title contents-label">W掲載商品数</label>
                      <div class="list-input-content">
                        <label><input type="checkbox" id="chk_MultiPublishItemCnt" forcedenabledmode="true" tabindex="0" [(ngModel)]="model.multiPublishItemCnt"
                        [disabled]="model.isMultiPublishItemCnt" (ngModelChange)="onChangeCheckBox()">対象</label>
                      </div>
                    </div>
                    <div class="column-list column-list-output">
                      <button id="btn_OutputOrderNumQuota" forcedenabledmode="true" class="btn-secondary btn-output" tabindex="0" [disabled]="model.isOrderNumQuotaButton"
                      (click)="onClickOutputOrderNumQuota()">
                        注文コード割当帳票出力
                      </button>
                    </div>
                  </div>

                </div>
                <!-- 注文コード割当（部門別） -->
                <wj-flex-grid
                  id="dtg_SelectedGoodsCount" #dtg_SelectedGoodsCount
                  [itemsSource]="model.orderDept" [isReadOnly]="true"
                  forcedEnabledMode="true" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'" [tabindex]="-1">
                  <wj-flex-grid-filter #fltr_orderDept></wj-flex-grid-filter>
                  <wj-flex-grid-column [minWidth]="5" [header]="'部門'" [width]="156" [binding]="'ClassCode'">
                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                      <div *ngIf="cell.item.ClassCode !== 'total' && cell.item.ClassCode !== 'max'">{{cell.item.ClassCode}}:{{cell.item.ClassName}}</div>
                      <div *ngIf="cell.item.ClassCode === 'total' || cell.item.ClassCode === 'max'">{{cell.item.ClassName}}</div>
                    </ng-template>
                  </wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'いばらき'" [width]="127" [binding]="'IbarakiGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'とちぎ'" [width]="127" [binding]="'TochigiGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'ぐんま'" [width]="127" [binding]="'GunmaGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'ちば'" [width]="127" [binding]="'ChibaGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'さいたま'" [width]="127" [binding]="'SaitamaGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'とうきょう'" [width]="127" [binding]="'TokyoGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'ながの'" [width]="127" [binding]="'NaganoGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                  <wj-flex-grid-column [minWidth]="5" [header]="'にいがた'" [width]="127" [binding]="'NiigataGoodsCount'" [align]="'right'"
                  ></wj-flex-grid-column>
                </wj-flex-grid>
              </div>
            </wj-tab>
          </div>
        </wj-tab-panel>
      </div>
    </td>
  </tr>

  <!-- フッター -->
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>